import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombresFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='APELLIDOS' htmlFor='input-apellidos' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='apellidos'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-apellidos'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombresFormGroup)
